<template>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css">
  <nav class="navbar navbar-expand-lg custom-navbar">
    <div class="container">
      <router-link to="/" class="text-decoration-none">
        <div class="logo-wrapper">
         <img :src="require('@/assets/logo_step_edge_web-3.png')" alt="StepEdge Academy"  />
        </div>
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">

        <li
            class="nav-item dropdown"
            v-for="(link, i) in navLinks"
            :key="i"
            :class="{ dropdown: link.subMenu }"
          >
            <template v-if="link.subMenu">
           <a
                class="nav-link dropdown-toggle text-white"
                href="/computer-science"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ link.name }}
              </a>
              <ul class="dropdown-menu custom-dropdown-menu">
                <li
                  v-for="(sublink, j) in link.subMenu"
                  :key="`sub-${i}-${j}`"
                >
                  <router-link class="dropdown-item" :to="sublink.path">
                    {{ sublink.name }}
                  </router-link>
                </li>
              </ul>
            </template>

            <template v-else>
              <router-link class="nav-link text-white" :to="link.path">
                {{ link.name }}
              </router-link>
            </template>
          </li>

        </ul>
      </div>
    </div>
  </nav>
  <!-- Breadcrumb.vue or directly inside a layout component -->
  <AppBreadcrumb />
  
  
</template>





<script>
import AppBreadcrumb from './AppBreadcrumb.vue';

export default {
 components: {
    AppBreadcrumb,
  },
 
  data() {
  return {
    navLinks: [
      { name: 'Home', path: '/' },
      { name: 'About Us', path: '/about-us' },
      {
        name: 'Secondary',
        subMenu: [
          { name: 'Computer Science', path: '/computer-science' },
           { name: 'Computational Thinking', path: '/computational-thinking' },
           { name: 'Artificial Intelligence', path: '/artificial-intelligence' },
          { name: 'Exam Boards', path: '/exam-boards' },
         
        ]
      },
      { name: 'School Partnerships', path: '/school-partnerships' },
      { name: 'Teaching Approach', path: '/teaching' },
      { name: 'Courses', path: '/courses' },
      { name: 'Testimonials', path: '/testimonials' },
      { name: 'Contact Us', path: '/contact' }
      //{ name: 'Blog', path: '/blog' }
    ]
  };
}


};


</script>
<style scoped>
.custom-navbar {
  background-color: #1B5E20; /* dark green */
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.navbar-nav .nav-link {
  color: white;
  transition: background-color 0.3s, color 0.3s;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}

.navbar-nav .nav-link:hover {
  background-color: #ffffff; /* White background on hover */
  color: #155724 !important;; /* Dark green text */
}


/* Dropdown Styling */

.custom-dropdown-menu {
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0;
}

.custom-dropdown-menu .dropdown-item {
  color: #155724; /* Dark green text */
}

.custom-dropdown-menu .dropdown-item:hover {
  background-color: #1B5E20; /* dark green */  /* light green hover */
  color: #ffffff !important; /* darker green on hover */
}
/* Make dropdown position correctly */
.nav-item.dropdown {
  position: relative;
}




/* logo css */
.logo-box {
  background-color: white;
  padding: 1px 16px;
  border-radius: 8px;
  display: inline-block;
  text-align: center;
}
.logo-text {
  font-family: 'Cinzel', serif; /* or Merriweather or Playfair Display */
  font-size: 23px;
  color: #2E7D32;
}
.logo-char {
  font-size: 36px;
}
.logo-sub {
  font-family: 'Cinzel', serif;
  font-size: 20px;
  color: #81C784;
}

.logo-wrapper img {
  height: 130px;
  width: auto;
}
</style>
